<template>
<div>
  <div v-if="!success" class="qaFeedback container">
    <Header v-show="!show" title="销售方质保信息"></Header>
    <div v-if="submitType==='code'">
      <div class="info margin-top-20">
        <!-- <div class="btn exchang-btn margin-left-25" @click="scanCode()">换货</div> -->
        <div class="info-item">
          <div class="title-sp">更换的新电瓶：</div>
          <div class="text-sp" @click="scanCode()"><van-icon name="scan" size="25"/></div>
        </div>
        <div v-if="Object.keys(exchangeInfo).length !== 0">
          <div class="margin-left-25 margin-top-10">产品信息</div>
          <div class="info-item">
            <div class="title">博世料号：</div>
            <div class="text">{{exchangeInfo.partNo}}</div>
          </div>
          <div class="info-item">
            <div class="title">产品名称：</div>
            <div class="text">{{exchangeInfo.partName}}</div>
          </div>
        </div>
      </div>

      <div class="footer">
          <div class="btn submit-btn" @click="handleSubmitCode()">确定</div>
      </div>

    </div>

    <div v-else>
            <div class="info" v-if="codeInfo.warrantyStatus===4&&submitType!=='resubmission'">
        <div class="info-item">
          <div class="title">博世料号：</div>
          <div class="text">{{codeInfo.partNo}}</div>
        </div>
        <div class="info-item">
          <div class="title">保单状态：</div>
          <div class="text">{{getItemStatus(codeInfo.warrantyStatus)}}<span v-if="codeInfo.warrantyStatus===4">({{codeInfo.verifyStatus}})</span></div>
        </div>
        <div class="info-item">
          <div class="title">质保单号：</div>
          <div class="text">{{codeInfo.warrantyCode}}</div>
        </div>
        <div class="info-item">
          <div class="title">产品名称：</div>
          <div class="text">{{codeInfo.partName}}</div>
        </div>
        <div class="info-item" v-if="codeInfo.carName">
          <div class="title">车型：</div>
          <div class="text">{{codeInfo.carName}}</div>
        </div>
        <div class="info-item" v-if="codeInfo.consumerMobile">
          <div class="title">车主手机号：</div>
          <div class="text">{{codeInfo.consumerMobile}}</div>
        </div>
        <div class="info-item">
          <div class="title">安装时里程数：</div>
          <div class="text">{{codeInfo.initMileage}}&nbsp;KM</div>
        </div>
        <div class="info-item">
          <div class="title">销售方名称：</div>
          <div class="text">{{codeInfo.workshopName}}</div>
        </div>
        <div class="info-item">
          <div class="title">销售方地址：</div>
          <div class="text">{{codeInfo.workshopAddress}}</div>
        </div>
        <div class="info-item">
          <div class="title">安装时间：</div>
          <div class="text">{{codeInfo.initTime?parseTime(codeInfo.initTime,'{y}-{m}-{d}'):''}}</div>
        </div>
        <div class="info-item" v-if="codeInfo.endTime">
          <div class="title">质保截至：</div>
          <div class="text">{{codeInfo.endTime?parseTime(codeInfo.endTime,'{y}-{m}-{d}'):''}}或者里程数到{{getFinalMileage()}}公里，以先到为准</div>
        </div>
        <div class="info-item">
          <div class="title">门店安装人员：</div>
          <div class="text">{{codeInfo.workshopPerson}}</div>
        </div>
      </div>

      <div v-if="(codeInfo.warrantyStatus===1||codeInfo.warrantyStatus===3||submitType=='resubmission')&&!isReplace">
        <div class="input-info">
          <div class="input-rm">
            <van-form error-message-align="right" :show-error="false" ref="selectedInput">

              <van-field
                  v-if="!codeInfo.consumerMobile"
                  v-model="data.consumerMobile"
                  placeholder="请输入车主手机号"
                  input-align="right"
                  :rules="[{  validator:validatorMobile, message: '请输入合法手机号'}]"
              >
              <template #label>
                <div style="display: flex; flex-direction: row; width: 4rem;">
                  <span style="margin-right: 0.2rem">联系电话</span>
                  <span @click="popupShow2 = true"> {{ data.iddCode }}<img style="width: 0.3rem; height: 0.17rem; margin: 0 0 0.05rem 0.1rem;" src="https://boshi2023.oss-cn-shanghai.aliyuncs.com/img/Polygon.png" alt="" ></span>
                </div>
              </template>
            </van-field>

              <van-field
                v-model="data.reportMileage"
                type="number"
                label="当前里程数："
                placeholder="请输入行驶里程"
                input-align="right"
                @blur="handleInitMileage"
                :rules="[{ validator:validatorKM, message: '请输入大于0的数字'}]"
              >
                <template #extra>
                  <div>&nbsp;KM</div>
                </template>
              </van-field>
            </van-form>
          </div>

            <div class="input-title">故障描述及判断：</div>
            <div class="input-textarea" style="padding: 0 10px 10px 10px;">
              <van-field
                v-model="data.warrantyDesc"
                type="textarea"
                placeholder="请输入问题描述"
                autosize
                clearable
                maxlength="45"
                show-word-limit
              ></van-field>
            </div>
            <div class="input-item">
              <div class="input-title">
                <div class="">电瓶二维码照片：</div>
                <div class="input-example" @click="showImg('/img/smartcode/qaExample1.jpg','image',true)">查看示例</div>
              </div>
              <div class="input-upload">
                <van-uploader
                  v-model="imgList1"
                  :after-read="afterRead1"
                  :before-read="beforeRead"
                  preview-size='25vw'
                  :before-delete="afterDelete1"
                  :disabled="isUploading?true:false"
                  :max-count='1'
                  >
                </van-uploader>
              </div>
            </div>

            <div class="input-item">
              <div class="input-title">
                <div class="">电瓶检测仪电压及CCA数值照片：</div>
                <div class="input-example"  @click="showImg('/img/smartcode/qaExample2.jpg','image',true)">查看示例</div>
              </div>
              <div class="input-upload">
                <van-uploader
                  v-model="imgList2"
                  :after-read="afterRead2"
                  :before-read="beforeRead"
                  preview-size='25vw'
                  :before-delete="afterDelete2"
                  :disabled="isUploading?true:false"
                  :max-count='1'
                  >
                </van-uploader>
              </div>
            </div>

            <div class="input-item">
              <div class="input-title">
                <div class="">电瓶连接检测仪整体照片：</div>
                <div class="input-example"  @click="showImg('/img/smartcode/qaExample3.jpg','image',true)">查看示例</div>
              </div>
              <div class="input-upload">
                <van-uploader
                  v-model="imgList3"
                  :after-read="afterRead3"
                  :before-read="beforeRead"
                  preview-size='25vw'
                  :before-delete="afterDelete3"
                  :disabled="isUploading?true:false"
                  :max-count='1'
                  >
                </van-uploader>
              </div>
            </div>
        </div>

      <div class="car-info" v-if="!codeInfo.carName">
        <van-cell-group :class="hasCarInfo?'spBlack':'spGrey'">
          <van-cell title="车型" :value="carName">
            <template #right-icon>
              <van-uploader
                v-model="files"
                :preview-image="false"
                :before-read="beforeReadCar"
                :after-read="fileSubmitted"
                >
                <div>&nbsp;<van-icon name="photograph" size="23" class="search-icon" /></div>
              </van-uploader>
            </template>
          </van-cell>
        </van-cell-group>
        <div class="tip-right">
          (请对准vin码)
        </div>
        <div class="privacy">
            <van-checkbox v-model="privacy" name="true">我已阅读并同意</van-checkbox>
        </div>
      </div>

      <div class="info margin-top-20" v-if="relationWarrantyId===''">
        <!-- <div class="btn exchang-btn margin-left-25" @click="scanCode()">换货</div> -->
        <div class="info-item">
          <div class="title-sp">更换的新电瓶：</div>
          <div class="text-sp" @click="scanCode()"><van-icon name="scan" size="25"/></div>
        </div>
        <div v-if="Object.keys(exchangeInfo).length !== 0">
          <div class="margin-left-25 margin-top-10">产品信息</div>
          <div class="info-item">
            <div class="title">博世料号：</div>
            <div class="text">{{exchangeInfo.partNo}}</div>
          </div>
          <div class="info-item">
            <div class="title">产品名称：</div>
            <div class="text">{{exchangeInfo.partName}}</div>
          </div>
        </div>
      </div>

        <div class="block-2"></div>

        <div class="footer">
          <div class="btn submit-btn" @click="submitFeedback()">
            <div v-if="loading">
              <van-loading class="loading" size="22px" color="#FFFFFF"  />
            </div>
            <div v-else v-points>
              确认
            </div>
          </div>
        </div>
      </div>

      <div v-if="(codeInfo.warrantyStatus===1||codeInfo.warrantyStatus===3)&&isReplace">
        <div class="footer">
          <div class="btn submit-btn" @click="submitQAInfo()">申请质保</div>
        </div>
      </div>

      <!-- <div v-if="(codeInfo.warrantyStatus===4||codeInfo.warrantyStatus===5)&&codeInfo.warrantyHistory"> -->
      <div v-if="codeInfo.warrantyStatus===4&&submitType!=='resubmission'">
        <div class="info">

          <div class="info-item">
            <div class="title">当前里程数：</div>
            <div class="text">{{codeInfo.warrantyHistory[0].reportMileage || ''}}&nbsp;KM</div>
          </div>
          <div class="info-item">
            <div class="title">故障描述及判断：</div>
          </div>
          <div class="info-item">
            <div>{{codeInfo.warrantyHistory[0].warrantyDesc || ''}}</div>
          </div>
          <div class="info-item">
            <div class="title">照片：</div>
          </div>
          <div class="info-item img-list">
            <div v-for="(item,index) of codeInfo.warrantyHistory[0].mediaList" :key="item.mediaId+index">
              <img @click="showImg(item.imageUrl,'image')" :src="item.imageUrl">
              <!-- <img v-if="getUrlType(item.imageUrl)==='video'" @click="showImg(item.imageUrl,'video')" src="https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/warranty/replacement.png"> -->
              <!-- <video autoplay class="video" v-if="getUrlType(item.imageUrl)==='video'" :src="item.imageUrl"  @click="showImg(item.imageUrl,'video')"></video> -->
            </div>
          </div>
        </div>
        <div class="block-1"></div>
        <!-- <div class="footer" v-if="!codeInfo.existUnite&&codeInfo.warrantyStatus!==5">
          <div class="btn submit-btn" @click="qaUnbound()">不质保并解绑</div>
        </div> -->
      </div>

      <div class="footer" v-if="codeInfo.warrantyStatus===4&&submitType!=='resubmission'">
          <div class="btn submit-btn" @click="gotoweb(true)">查看换货后的保单</div>
      </div>

      <!-- <div class="footer" v-if="codeInfo.warrantyStatus===6">
        <div class="btn submit-btn" @click="gotoweb(true)">查看换货后的保单</div>
      </div> -->

      <van-overlay :show="show" @click="show = false">
        <div class="wrapper" >
          <div class="img-block">
            <!-- <div  v-if="urlType==='image'" :style="'background-image: url('+url+');'" class="block-img">
            </div> -->
            <img v-if="urlType==='image'"   :src="url">
            <video autoplay class="video" v-if="urlType==='video'" :src="url" controls></video>

          </div>
            <img v-if="urlType==='video'"
              @click="show=false"
              class="video-delete"
              src="../../../assets/images/activity/form-verification-off.png"
            >
        </div>
      </van-overlay>
    </div>

  </div>

  <div v-else class="success">
    <Header title="提交成功"></Header>

    <div class="result-info">
      <img src="../../../assets/images/activity/form-verification-right.png" alt="">
      <div class="result-info-text"> 提交成功</div>
    </div>

    <div class="footer">
      <div class="btn submit-btn" @click="goBack()">确定</div>
    </div>
  </div>
  <van-popup v-model="popupShow2" round position="bottom">
      <van-picker show-toolbar :columns="phoneArray"  @confirm="onConfirm" @cancel="onCancel"/>
    </van-popup>
</div>

</template>

<script>
import Header from '../../../components/header.vue'
import { commonUtils } from '@/utils/common'
import activityApi from '@/api/activity'
import fileApi from '@/api/file'
import Compress from 'compress.js'
export default {
  components: { Header },
  data () {
    return {
      value: '',
      code: '',
      codeInfo: {},
      warrantyId: '',
      data: {
        reportMileage: '',
        warrantyDesc: '',
        mediaFileIds: '',
        warrantyId: '',
        partQrCode: '',
        warrantyCode: '',
        consumerMobile: '',
        carName: '',
        carId: '',
        iddCode: '+86'
      },
      fileList: [],
      fileId: [],
      fileUri: [],
      success: false,
      show: false,
      url: '',
      urlType: '',
      videourl: '',
      allInfoList: [],
      loading: false,
      isUploading: false,
      imgList1: [],
      imgList2: [],
      imgList3: [],
      isReplace: '',
      exchangeInfo: {},
      partQrCode: '',
      relationWarrantyId: '',
      hasCarInfo: false,
      carName: '请上传图片识别VIN码',
      privacy: false,
      files: [],
      submitType: '',
      imgFile1: {},
      imgFile2: {},
      imgFile3: {},
      popupShow2: false,
      phoneArray: [ '中国大陆 +86', '中国香港 +852', '中国澳门 +853', '中国台湾 +886' ]
    }
  },
  watch: {
    'allInfoList' () {
      this.imgList = []
      for (let item of this.allInfoList) {
        let data = {
          type: item.type,
          name: item.originalName,
          url: item.type === 'video' ? 'https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/warranty/replacement.png' : commonUtils.getImageUrl(item.fileUri) // 'https://img.bosch-extra.com.cn:8443/public-tmp/8A/e11fc31e-2496-45f3-ad7d-9e415c953a3d.jpg' // 'https://img.bosch-extra.com.cn:8443/' + item.fileList
        }
        this.imgList.push(data)
        console.log(this.imgList)
      }
    }
  },
  created () {
    commonUtils.configWxJsSdk().catch(error => {
      this.$emit('error', { errorMsg: error })
    })
    this.warrantyId = this.$route.query.warrantyId
    this.submitType = this.$route.query.submitType
    this.init()
  },
  mounted () {
    const u = navigator.userAgent
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    console.log('isIOS', isIOS)
    if (isIOS && location.href.indexOf('#reloaded') === -1) {
      location.href = location.href + '#reloaded'
      location.reload()
    }
  },
  methods: {
    onConfirm (e) {
      this.data.iddCode = e.substr(5)
      this.popupShow2 = false
    },
    onCancel () {
      this.popupShow2 = false
    },
    parseTime: commonUtils.parseTime,
    init () {
      let params = {
        warrantyId: this.warrantyId
      }
      activityApi.getQaFeedbackInfo(params).then(res => {
        if (res.data.resultCode === '0') {
          this.codeInfo = res.data.resultData.warrantyInfo
          this.relationWarrantyId = this.codeInfo.relationWarrantyId || ''
          this.privacy = !!this.codeInfo.carName
          let warrantyHistory = res.data.resultData.warrantyInfo.warrantyHistory || []
          if (warrantyHistory && warrantyHistory.length > 0) {
            this.data.warrantyDesc = warrantyHistory[0].warrantyDesc
            this.data.reportMileage = warrantyHistory[0].reportMileage
            // this.imgList1[0] = warrantyHistory[0].mediaList[0].imageUrl
            this.imgList1[0] = this.imgFile1 = {
              url: warrantyHistory[0].mediaList[0].imageUrl,
              fileId: warrantyHistory[0].mediaList[0].imageId
            }
            this.imgList2[0] = this.imgFile2 = {
              url: warrantyHistory[0].mediaList[1].imageUrl,
              fileId: warrantyHistory[0].mediaList[1].imageId
            }
            this.imgList3[0] = this.imgFile3 = {
              url: warrantyHistory[0].mediaList[2].imageUrl,
              fileId: warrantyHistory[0].mediaList[2].imageId
            }
          }
        }
      })
    },
    validatorKM (val) {
      let reg = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g
      if ((reg.test(val) && Number(val) > 0)) return true
      return false
    },
    validatorMobile (val) {
      let reg = /^(1[3-9]\d{9})$|^(\d{8})$|^(\d{9})$/
      if (reg.test(val)) return true
      return false
    },
    handleInitMileage () {
      let distance = Number(this.data.reportMileage).toFixed(2)
      console.log(typeof this.data.reportMileage)
      this.data.reportMileage = distance
    },
    gotoweb (isReplace) {
      if (isReplace) {
        this.warrantyId = this.relationWarrantyId
        this.data = {
          reportMileage: '',
          warrantyDesc: '',
          mediaFileIds: '',
          warrantyId: '',
          partQrCode: '',
          warrantyCode: ''
        }
        this.fileId = []
        this.fileUri = []
        this.imgList1 = []
        this.imgList2 = []
        this.imgList3 = []
        this.allInfoList = []
        this.relationWarrantyId = ''
        this.exchangeInfo = {}
        this.init()
      } else {
        let data = JSON.stringify(this.codeInfo)
        sessionStorage.setItem('codeInfo', data)
        this.$router.push({ name: 'quality-assurance-ws-info' })
      }
    },
    getFinalMileage () {
      return Number(this.codeInfo.endMileage)
    },
    getUrlType (url) {
      let data = url.split('.')
      let imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
      let videolist = ['mp4', 'm2v', 'mkv']
      let type = data[data.length - 1]
      if (imglist.indexOf(type) !== -1) {
        return 'image'
      } else if (videolist.indexOf(type) !== -1) {
        return 'video'
      }
    },
    getItemStatus (status) {
      switch (status) {
        case 1:
          return '销售方激活'
        case 2:
          return '车主未领取'
        case 3:
          return '车主已领取'
        case 4:
          return '质保已提交'
        case 5:
          return '已失效'
        default:
          break
      }
    },
    showImg (url, type, isSample) {
      if (isSample) {
        this.url = this.$getImgUrl(url)
      } else {
        this.url = url
      }
      this.urlType = type
      this.show = true
    },
    back () {
      this.success = false
      this.init()
    },
    beforeRead (file) {
      console.log(file)
      console.log(file.type.startsWith('image'))
      if (!file.type.startsWith('image') && !file.type.startsWith('video')) {
        this.$toast('请上传图片')
        return false
      }
      return true
    },
    afterRead1 (file) {
      this.afterRead(file, 1)
    },
    afterRead2 (file) {
      this.afterRead(file, 2)
    },
    afterRead3 (file) {
      this.afterRead(file, 3)
    },
    afterRead (file, type) {
      file.status = 'uploading'
      file.message = '上传中...'
      this.isUploading = true
      fileApi
        .uploadFilePublic(file.file)
        .then((response) => {
          if (response.data.resultCode === '0') {
            let fileDTO = response.data.resultData.fileDTO
            file.status = ''
            file.message = ''
            if (file.file.type.startsWith('image')) {
              fileDTO.type = 'image'
            }
            this['imgFile' + type] = fileDTO
            // this.allInfoList.push(fileDTO)
            // console.log(this.allInfoList)
            this.isUploading = false
          } else {
            this['imgFile' + type] = {}
            this['imgList' + type] = []
            // this.handleDelete(file.file.name)
          }
          file.status = ''
          file.message = ''
          this.isUploading = false
        })
        .catch((error) => {
          console.log(error)
          this['imgFile' + type] = {}
          this['imgList' + type] = []
          // this.handleDelete(file.file.name)
          file.status = ''
          file.message = ''
          this.isUploading = false
        })
    },
    getUrl (uri) {
      return commonUtils.getImageUrl(uri)
    },
    // handleclicksc (file) {
    //   let name = file.name
    //   for (let item of this.allInfoList) {
    //     if (item.type === 'video' && item.originalName === name) {
    //       this.url = this.getUrl(item.fileUri)
    //       this.urlType = 'video'
    //       this.show = true
    //     }
    //     if (item.type === 'image' && item.originalName === name) {
    //       this.url = this.getUrl(item.fileUri)
    //       this.urlType = 'image'
    //       this.show = true
    //     }
    //   }
    // },
    // handleDelete (name) {
    //   this.imgList.forEach((item, index) => {
    //     if (item.file.name === name) {
    //       this.imgList.splice(index, 1)
    //     }
    //   })
    // },
    afterDelete1 (file) {
      this.afterDelete(file, 1)
    },
    afterDelete2 (file) {
      this.afterDelete(file, 2)
    },
    afterDelete3 (file) {
      this.afterDelete(file, 3)
    },
    afterDelete (file, type) {
      if (this.codeInfo.verifySign && this.codeInfo.verifySign === '04') {
        this['imgList' + type] = []
        this['imgFile' + type] = []
      } else {
        this['imgList' + type] = []
        // let name = file.file.name
        // this.allInfoList.forEach((item, index) => {
        //   if (item.originalName === name) {
        //     this.allInfoList.splice(index, 1)
        //   }
        // })
        return true
      }
    },
    validatePhoneNumber (phoneNumber) {
      const that = this
      // 手机号正则表达式
      let phoneRegEx
      if (that.data.iddCode === '+86') {
        phoneRegEx = /^1[3456789]\d{9}$/
        return phoneRegEx.test(phoneNumber)
      } else if (that.data.iddCode === '+852') {
        phoneRegEx = /^\d{8}$/
        return phoneRegEx.test(phoneNumber)
      } else if (that.data.iddCode === '+853') {
        phoneRegEx = /^\d{8}$/
        return phoneRegEx.test(phoneNumber)
      } else if (that.data.iddCode === '+886') {
        phoneRegEx = /^\d{9}$/
        return phoneRegEx.test(phoneNumber)
      }
    },
    submitFeedback () {
      if (this.isUploading) {
        this.$toast('正在上传...')
        return
      }
      for (let item of this.allInfoList) {
        this.fileId.push(item.fileId)
        this.fileUri.push(item.fileUri)
      }
      // this.loading = true
      // let mediaFileIds = this.fileId.join(',')
      this.data.mediaFileIds = this.imgFile1.fileId + ',' + this.imgFile2.fileId + ',' + this.imgFile3.fileId
      this.data.warrantyId = this.warrantyId
      this.data.warrantyCode = this.codeInfo.warrantyCode
      this.$refs.selectedInput.validate().then(res => {
        // if (!this.data.partQrCode) {
        //   this.$dialog.alert({
        //     message: '请在更换的新电瓶处扫描产品码'
        //   }).then(() => {
        //   })
        //   return
        // }
        if (!this.validatePhoneNumber(this.data.consumerMobile)) {
          this.$dialog.alert({
            message: '请选择正确的手机区号！'
          }).then(() => {
          })
          return
        }
        if (this.imgList1.length === 0 || !this.imgFile1.fileId) {
          this.imgFile1 = {}
          this.imgList1 = []
          this.$dialog.alert({
            message: '请上传电瓶二维码照片'
          }).then(() => {
          })
          return
        } else if (this.imgList2.length === 0 || !this.imgFile2.fileId) {
          this.imgFile2 = {}
          this.imgList2 = []
          this.$dialog.alert({
            message: '请上传电瓶检测仪电压及CCA数值照片'
          }).then(() => {
          })
          return
        } else if (this.imgList3.length === 0 || !this.imgFile3.fileId) {
          this.imgFile3 = {}
          this.imgList3 = []
          this.$dialog.alert({
            message: '请上传电瓶连接检测仪整体照片：'
          }).then(() => {
          })
          return
        } else if (!this.codeInfo.carName && !this.data.carName) {
          this.$dialog.alert({
            message: '请上传图片识别VIN码'
          }).then(() => {
          })
          return
        } else if (!this.privacy) {
          this.$toast.fail('请阅读并同意关于VIN的隐私条款')
        }
        activityApi.submitFeedback(this.data).then(res => {
          if (res.data.resultCode === '0') {
            this.relationWarrantyId = res.data.resultData.electronicWarrantyInfo.relationWarrantyId
            this.success = true
            this.loading = false
          } else {
            this.loading = false
            this.$notify({
              background: '#1989fa',
              message: res.data.resultMsg,
              className: 'notify-error-msg'
            })
          }
        }).catch(() => {
          this.loading = false
        })
      }).catch(err => {
        console.log(err)
      })
    },
    qaUnbound () {
      this.$dialog.confirm({
        title: '操作提示',
        message: '该操作会导致车主提交质保无效，是否确定不质保并解除绑定？'
      })
        .then(() => {
          let data = {
            warrantyId: this.warrantyId
          }
          activityApi.qaUnbound(data).then(res => {
            if (res.data.resultCode === '0') {
              this.$dialog.alert({
                message: '解绑成功！'
              })
              this.init()
            } else {
              this.$notify({
                background: '#1989fa',
                message: res.data.resultMsg,
                className: 'notify-error-msg'
              })
            }
          })
        }).catch(() => {
        })
    },

    submitQAInfo () {
      this.isReplace = ''
    },
    beforeReadCar () {
      if (!this.privacy) {
        this.$toast.fail('请阅读并同意关于VIN的隐私条款')
        return false
      }
      this.files = []
      return true
    },
    fileSubmitted (file) {
      if (file.file.size < 1024 * 1024 * 3) {
        this.recognizeVin(file)
      } else {
        const compress = new Compress()
        compress.compress([file.file], {
          size: 4,
          quality: 0.75,
          maxWidth: 2000,
          maxHeight: 2000,
          resize: true
        }).then(results => {
        // console.log(results)
          const img = results[0]
          const base64Str = img.prefix + img.data
          const fileObj = commonUtils.convertBase64ToFile(base64Str, file.file.name)
          const compressedFile = {
            content: base64Str,
            file: fileObj
          }
          console.log(compressedFile)
          if (compressedFile.file.size > this.imageSizeLimit) {
            this.$toast('上传图片不能大于3M')
          } else {
            this.recognizeVin(compressedFile)
          }
        })
      }
    },
    recognizeVin (file) {
      const toast = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '正在识别...'
      })
      activityApi.queryCarByVinImg({ imageBase64Data: file.content }).then(response => {
        toast.clear()
        if (response.data.resultCode === '0') {
          let vinCode = response.data.resultData.vinCode
          this.codeInfo.vinCode = vinCode
          let params = {
            vinCode
          }
          activityApi.getCarName(params).then(res => {
            if (res.data.resultCode === '0') {
              this.codeInfo.vinCode = vinCode
              this.carName = res.data.resultData.carInfoList[0].carFullInfo
              this.data.carName = this.carName
              this.data.carId = res.data.resultData.carInfoList[0].carId
              this.hasCarInfo = true
            } else {
              // this.carName = '请上传图片识别VIN码'
              // delete this.data.carName
              this.carName = vinCode
              this.data.carName = vinCode
              this.hasCarInfo = true
            }
          }).catch(err => {
            console.log(err)
            // this.carName = '请上传图片识别VIN码'
            // delete this.data.carName
            this.carName = vinCode
            this.data.carName = vinCode
            this.hasCarInfo = true
          })
        } else {
          this.carName = '请上传图片识别VIN码'
          delete this.data.carName
          delete this.codeInfo.vinCode
          this.hasCarInfo = false
        }
      }).catch(err => {
        toast.clear()
        console.log(err)
        this.carName = '请上传图片识别VIN码'
        delete this.data.carName
        delete this.codeInfo.vinCode
        this.hasCarInfo = false
      })
    },
    showPrivacy () {
      this.$router.push({ name: 'privacy', home: false })
    },

    handleSubmitCode () {
      this.data.warrantyId = this.warrantyId
      activityApi.qaReplaceCodeScan(this.data).then((res) => {
        if (res.data.resultCode === '0') {
          this.success = true
        } else {
          this.loading = false
          this.$notify({
            background: '#1989fa',
            message: res.data.resultMsg,
            className: 'notify-error-msg'
          })
        }
      })
    },

    goBack () {
      this.$router.push({ name: 'quality-assurance-ws-feedback', query: { warrantyId: this.warrantyId, type: 'info' } })
    },

    // 扫码
    scanCode () {
      // console.log(111)
      // let code = {
      //   // warrantyCode: '16413693403640092S47338'
      //   // partQrCode: 'https://qr.bosch-extra.com.cn:8443/18673b18-eeb7-4386-9bca-0370bf3b8bf5'
      //   scanCode: 'https://qr.bosch-extra.com.cn:8443/0208f86c-7f8d-4d8c-96ff-eb1d05f7987a'
      // }
      // this.data.partQrCode = code.scanCode
      // this.scanResult(code)
      // return 0

      this.$wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['barCode', 'qrCode', 'datamatrix', 'pdf417'], // 可以指定扫二维码还是一维码，默认二者都有
        success: res => {
          let scanData
          scanData = {
            scanCode: res.resultStr
          }
          this.data.partQrCode = res.resultStr
          this.partQrCode = res.resultStr
          this.getLocation(scanData)
        },
        fail: res => {
          this.$toast('调用扫码功能异常')
          console.log('fail', res)
        },
        cancel: function () {
          console.log('scan cancel')
        }
      })
    },

    // 获取经纬度
    getLocation (scanData) {
      this.$wx.getLocation({
        type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: res => {
          scanData.locLat = res.latitude // 纬度，浮点数，范围为90 ~ -90
          scanData.locLong = res.longitude // 经度，浮点数，范围为180 ~ -180。
          this.scanResult(scanData)
        },
        fail: function (err) {
          console.log(err)
        }
      })
    },

    // 扫码结果
    scanResult (value) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })
      value.warrantyCode = this.codeInfo.warrantyCode
      activityApi.qaScan(value).then(res => {
        this.$toast.clear()
        if (res.data.resultCode === '0') {
          if (res.data.resultData.electronicWarrantyInfo) {
            this.exchangeInfo = res.data.resultData.electronicWarrantyInfo
            // console.log(res.data)
            // this.$dialog.alert({
            //   message: '换货成功，请查看保单信息'
            // }).then(() => {
            //   // this.codeInfo = res.data.resultData.electronicWarrantyInfo
            //   // this.isReplace = res.data.resultData.isReplace
            // })
          }
        } else {
          this.$notify({
            background: '#1989fa',
            message: res.data.resultMsg,
            className: 'notify-error-msg'
          })
        }
      }).catch(() => {
        this.$toast.clear()
      })
    }
  }
}
</script>

<style lang="less" scoped>
// @media (max-height: 450px){
//   .footer {
//     position: static !important;
//   }
// }
.block-1{
  width: 100%;
  height: 50px;
}
.block-2{
  width: 100%;
  height: 80px;
}

.block-img{
  width: 100vw;
  height: 100vh;
  z-index: 200;
  position: absolute;
  top: 0;
  z-index: 200;
}
.container{
  position: relative;
  top: 46px;
}
.result-info{
  text-align: center;
  padding: 90px 0 20px 0;
  img{
    width: 80px;
  }
  .result-info-text{
    padding: 25px 0 5px 0;
    font-size: 16px;
  }
}
.info{
  position: relative;
  padding: 10px 0;
 // margin: 20px;
  margin: 0 5px;
  background-color: white;
  border-radius: 5px;
}
.btn{
  width: 100%;
  text-align: center;
  border-radius: 3px;
  color: white;
  background-color: rgb(17, 114, 129);
}
.submit-btn{
  margin: 10px;
  padding: 12px;
}
.exchang-btn{
  width: 30px;
  padding: 5px 10px;
}
.footer{
  width: 100vw;
  background-color: white;
  position: fixed;
  bottom: 0px;
  display: flex;
  justify-content: space-evenly;
}
.info-item{
  display: flex;
  .title{
    min-width: 100px;
    word-break: keep-all;
    color: gray;
  }
  .title-sp{
    color: black;
  }
  .text-sp{
    font-size: 20px;
  }
  word-break:break-all;
}
.input-info{
  top: 10px;
  position: relative;
  padding: 10px;
 // margin: 20px;
  margin: 10px 5px 0 5px;
  background-color: rgb(255, 255, 255) !important;
  border-radius: 5px;
  .van-field__label{
    color: red;
  }
}
.info-item{
  margin: 15px 25px;
  display: flex;
  justify-content: space-between;
  .title{
    color: gray;
  }
}
.score-field .van-field {
  background: #f1f1f1;
  border-radius: 3px;
}
.input-textarea .van-cell{
  background: #f8f8f8;
}
.input-title{
  margin: 15px 17px;
  color: rgb(22, 22, 22);
  display: flex;
  justify-content: space-between;
}
.input-example{
  color: rgb(28, 154, 212);
  font-size: 12px;
}
.input-upload{
  margin: 0 12px;
}
.img-list{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  img{
    width: 24vw;
    height: 24vw;
    object-fit: cover;
    padding: 5px;
  }
  video{
    width: 24vw;
    height: 24vw;
    margin-right: 10px;
    padding: 5px;
  }
}

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .img-block {
    position: relative;
    img{
      z-index: 99;
      width: 100vw;
      height: auto;
      object-fit: cover;
    }
    video{
      width: 100%;
      max-height: 100vh;
    }
  }
  .video-delete{
    width: 45px;
    position: absolute;
    top: 60px;
    left: calc(100vw - 60px);
  }
  .loading{
    height: 14px;
    display: inline-block;
  }
  .video-cover{
  width: 25vw;
  height: 25vw;
  background-color: black;
}
.cover-img{
  width: 10vw;
  height: 10vw;
  padding: 7.5vw;
  background-color: black;
}
.margin-top-10{
  margin-top: 10px;
}
.margin-left-25{
  margin-left: 25px;
}
.color-red{
  background-color: rgb(235, 8, 8);
}
.margin-top-20 {
  margin-top:20px;
}

.car-info{
  top: 10px;
  position: relative;
  padding: 10px;
 // margin: 20px;
  margin: 10px 5px 0 5px;
  background-color: rgb(255, 255, 255) !important;
  border-radius: 5px;
 .van-field__label{
    width: 13rem;
  }
  .spGrey .van-cell__value{
    color: #d1d1d1;
  }
  .spBlack .van-cell__value{
    color: #000000;
  }
  .van-cell__value{
    min-width: 230px;
  }
.privacy{
  display: flex;
  background-color: white;
  padding:5px 15px 15px 15px;
  width: calc(100% - 30px);
  .link{
    color: rgb(39, 148, 211);
    text-decoration: underline;
    line-height: 21px;
    margin-left: 10px;
  }
}
}
  .tip-right{
    font-size: 12px;
    line-height: 20px;
    color: #999;
    width:calc(100vw - 40px);
    background-color: #fff;
    padding:0 10px;
    text-align: right;
  }
</style>
